import { ColorNames } from '@/utils/constants';
import { isRichTextContent } from '@/utils/resolvers/content-blocks';

export const mapContainerPropsToComponentProps = (
  variant: string,
  containerProps: any = {},
  componentProps: any = {},
) => {
  if (/contentList/.test(variant)) {
    return {
      ...componentProps,
      presentation: {
        ...componentProps.presentation,
        containerBottomBackgroundColor: containerProps.bottomBackgroundColor,
        containerTopBackgroundColor: containerProps.topBackgroundColor,
        containerBottomSpacing: containerProps.bottomSpacing,
        containerTopSpacing: containerProps.topSpacing,
      },
    };
  }

  if (/tabbedList/.test(variant)) {
    return {
      ...containerProps,
      ...componentProps,
      containerBottomBackgroundColor: containerProps.bottomBackgroundColor,
      containerTopBackgroundColor: containerProps.topBackgroundColor,
      containerBottomSpacing: containerProps.bottomSpacing,
      containerTopSpacing: containerProps.topSpacing,
    };
  }

  if (/formPicker/.test(variant)) {
    return {
      containerColor:
        containerProps.topBackgroundColor ||
        containerProps.bottomBackgroundColor ||
        ColorNames.eggshell,
      ...containerProps,
      ...componentProps,
    };
  }

  if (/image/.test(variant)) {
    return {
      ...componentProps,
      base: 'small',
      image: {
        ...componentProps.image,
        fullWidthImage: true,
      },
    };
  }

  if (isRichTextContent(variant)) {
    return {
      content: componentProps?.rtc || '',
      ...containerProps,
      ...componentProps,
    };
  }

  return {
    ...containerProps,
    ...componentProps,
  };
};
